module.exports = __webpack_public_path__ + "img/connected.5ff2d333.svg";